import React from 'react'
import maleIcon from 'assets/Images/maleIcon.svg'
import femaleIcon from 'assets/Images/femaleIcon.svg'
import coedIcon from 'assets/Images/coedIcon.svg'
import { LeagueFinalResp } from 'types/league/league'
import { leagueEventStore } from 'state/league/leagueEvent'
import { capitalizeFirstLetter } from 'helper/utility'


const genderIcons: Record<string, string> = {
  male: maleIcon,
  female: femaleIcon,
  coed: coedIcon,
}
const GeneralDetail: React.FC = () => {
  const { leagueData }: { leagueData: LeagueFinalResp } = leagueEventStore(
    store => ({
      leagueData: store.leagueData,
    }),
  )

  return (
    <>
      <h3 className="main-heading">About League</h3>
      <p className="para desc">{leagueData.description}</p>
      <div className="divisions_container">
        {leagueData.divisions.map(division => {
          return (
            <div key={division._id} className="division">
              <div className="img_cont">
                <img
                  src={genderIcons[division.genders?.[0] ?? ''] ?? coedIcon}
                  alt="division"
                />
              </div>
              <div>
                <h3>{division.genders?.map(gender => capitalizeFirstLetter(gender)).join(', ')}</h3>
                <p>
                  {division.ageGroups?.map(age => age.name).join(', ')} • {division.skillLevels?.map(skill => skill.name).join(', ')}
                </p>
                {/* <p>Under 13 • Medium</p> */}
              </div>
            </div>
          )
        })}
      </div>

      <div className="items_to_bring_container">
        <h3 className="main-heading">Items to bring</h3>
        <div className="items_to_bring">
          {leagueData.itemsToBring.length > 0 ? (
            leagueData.itemsToBring.map(item => {
              return (
                <div key={item._id} className="item">
                  <img src={item.icon.thumb} alt="item" />
                  <h4>{item.name}</h4>
                </div>
              )
            })
          ) : (
            <div className="item">
              <h4>No items are added</h4>
            </div>
          )}
        </div>
      </div>

      <div className="disclamier_container">
        <h3 className="main-heading">Disclaimer</h3>
        <p className="para">All refunds will provided as credit.</p>
        <p className="para">
          Late pickup begins 15 minutes after the end of the event which may
          constitute in a $1 / minute late fee.
        </p>
      </div>
    </>
  )
}

export default GeneralDetail
